<template>
  <router-view>
    
  </router-view>
</template>

<script>
  export default {
    name: `ExamineePage`,
  }
</script>

<style lang="css" scoped>
body {
  height:100%
}
</style>